$(document).ready(function () {


  // check if cookie is set
  if (document.cookie.indexOf("offter_popup_closed=true") === -1) {
    //$('#offter-section-popup').fadeIn();
    // make flex container
    //$('#offter-section-popup').css('display', 'flex');
  }

  $('#offter-section-popup').on('click', function () {
    $('.main-promo-popup').fadeIn();
  });


  // click close button
  $('#offter-section-popup img').on('click', function () {
    $('#offter-section-popup').fadeOut();
    // set cookie to remember user closed the popup and close for 1 day
    document.cookie = "offter_popup_closed=true; path=/; max-age=" + 24 * 60 * 60;
  });

  $(".main-promo-popup .main-promo-popup-content .main-promo-popup-close").on("click", function () {
    $(".main-promo-popup").fadeOut();
  });


  // start code 
  var $topbar = $(".menu-top-bar");
  var isHidden = false; // Tracks if topbar is hidden

  $(window).on("scroll", function () {
    var scrollTop = $(this).scrollTop();

    if (scrollTop > 100 && !isHidden) {
      $topbar.stop(true, true).slideUp(300, function () {
        $topbar.addClass("hide-topbar");
      });
      isHidden = true;
    }

    if (scrollTop <= 100 && isHidden) {
      $topbar.removeClass("hide-topbar").stop(true, true).slideDown(300);
      isHidden = false;
    }
  });

  // end code 

  document.addEventListener("DOMContentLoaded", function () {
    const bar = document.querySelector(".menu-top-bar");
    if (!bar) return;

    let lastScrollTop = 0;

    window.addEventListener("wheel", function (e) {
      const st = window.scrollY || document.documentElement.scrollTop;

      if (e.deltaY > 0 && st > lastScrollTop) {
        // user scrolled DOWN with mouse
        bar.classList.add("hide-topbar");
      } else if (e.deltaY < 0 && st < lastScrollTop) {
        // user scrolled UP with mouse
        bar.classList.remove("hide-topbar");
      }

      lastScrollTop = st <= 0 ? 0 : st; // avoid negative values
    }, { passive: true });
  });

  $('.menu-top-bar').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    dots: false,
    autoplaySpeed: 2000,
  });


  $('.size-tabs-wrapper .size-tabs li').click(function (e) { 
    e.preventDefault();

    var size = $(this).data('size');

    // Remove active class from all tabs
    $('.size-tabs-wrapper .size-tabs li').removeClass('active');

    // Add active class to clicked tab
    $(this).addClass('active');

    // Hide all tab content
    $('.size-tabs-wrapper .tab-content').removeClass('active');

    // Show content for selected tab
    $('.size-tabs-wrapper .tab-content[data-size="' + size + '"]').addClass('active');
  });

  document.addEventListener("DOMContentLoaded", function() {
  // Override Currency.formatMoney to round to integer values
  if (window.Currency && typeof Currency.formatMoney === 'function') {
    const originalFormatMoney = Currency.formatMoney;
    Currency.formatMoney = function(cents, format) {
      // Convert cents to major unit
      let value = parseFloat(cents) / 100;
      // Round to nearest integer
      value = Math.round(value);
      // Rebuild cents (Shopify expects cents integer)
      const newCents = value * 100;
      // Force to use no-decimal format
      format = format.replace('{{amount}}', '{{amount_no_decimals}}');
      return originalFormatMoney(newCents, format);
    };
  }
});


});


